import { normalize, schema } from 'normalizr';

export const entity = 'adminShop';
export const endpoints = {
  all: {
    url: '/admin/shops/all',
    entity,
    list: true,
  },
};
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'shopID',
  }
);
export const listNormalizer = (result) => normalize(result, [entitySchema]);
